<script>
    export let prop;
    export let cosito;
</script>

<r-grid columns=3>
    <r-col><p>{prop}</p></r-col>
    <r-col></r-col>
    <r-col><p>{cosito}</p></r-col>
</r-grid>